
<template>
	<Component :is="require(`@/assets/icons/${name}.svg?inline`).default" :class="class_name + ' ' + size" v-bind="$attrs" @v-on="$listeners" v-on:click="() => $emit('click')" />
</template>
  
<script>
export default {
    name: 'BaseIcon',
    
    inheritAttrs: false,

    props: {
        name: {
            type: String,
            required: true,
        },
        size: { type: String, default: () => "" },
        animation_spin: { Boolean, default: () => false}
    },

    data()
    {
        return {
            init_class_name : "BaseIcon",
            class_name : "BaseIcon",
        }
    },

    watch : 
    {
        animation_spin()
        {
            this.animation_spin ? this.class_name = this.class_name + " animation-spin" : this.class_name = this.init_class_name
        }
    },
}
</script>
  
<style>
.animation-spin
{	
	animation-name: spin;
	animation-duration: 2500ms;
	animation-iteration-count: infinite;
	animation-timing-function: linear;
}

@keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
}
</style>

<style scoped>
.md
{
    transform: scale(.833333333);
}
</style>
